<template>
  <div class="owner-box">
    <div class="main-container">
      <h3 class="">{{disp_date_text}} 清掃状況</h3>
      <div class="list-box">
        <div v-for="item in work_list" :key="item.listing_id" @click="list_info(item)">
          <p class="status" :class="`status${item.status}`">{{status_text(item.status)}}</p>
          <p class="room-name">{{item.listing_name}}</p>
          <p class="time" v-if="item.complete_time">[{{item.complete_time}}]</p>
          <p class="time" v-else>[-]</p>
        </div>
      </div>
      <div class="date-box">
        <datepicker
          v-model="date_obj"
          :inline="true"
          :format="'YYYYMMDD'"
          :height="400"
          :holidays="holidays"
          :schedules="clean_list"
          @changed_month="data_get"
          @selected="checkout_list_get"
        />
      </div>
      <input type="button" class="button" value="情報更新" @click="renew">
    </div>
  </div>
</template>

<script>
import Datepicker from '@/components/datepicker';
export default {
  name: 'Owner',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    Datepicker,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      date_obj: new Date(),
      holidays: [],
      work_list: [],
      disp_date: '',
      clean_list: {},
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    disp_date_text () {
      return `${this.disp_date.substr(0, 4)}/${this.disp_date.substr(4, 2)}/${this.disp_date.substr(6, 2)}`;
    }
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
    this.get_hol();
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    let date;
    if (this.$route.params.date) {
      this.disp_date = this.$route.params.date;
      date = this.$route.params.date;
      this.date_obj = this.$lib._date_string_convert(date);
    } else {
      date = this.$lib._date_text_get(this.date_obj);
    }

    this.data_get(date.substr(0, 6));
    this.checkout_list_get(date);
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    data_get (ym) {
      let ld = new this.$loader(this);
      ld._data_set({ym: ym});
      ld._post_cb_f = this.data_get_cb;
      ld._load_start('admin_cleaner_calendar_get.php');
    },
    data_get_cb (res) {
      this.clean_list = res.data.calendar;
    },
    get_hol () {
      const st = this.$store.getters['holidays/holidays'];
      console.log(st.length);
      if (st.length) {
        this.holidays = st;
      } else {
        let ld = new this.$loader(this);
        ld._data_set({});
        ld._post_cb_f = this.get_hol_cb;
        ld._load_start('holiday_get.php');
      }
    },
    get_hol_cb (res) {
      this.holidays = res.data.holidays;
      this.$store.commit('holidays/set_holidays', res.data.holidays);
    },
    checkout_list_get (date) {
      if (date.substr(0, 6) != this.disp_date.substr(0, 6)) {
        this.data_get(date.substr(0, 6));
      }
      this.disp_date = date;
      let ld = new this.$loader(this);
      ld._data_set({date: date});
      ld._post_cb_f = this.checkout_list_get_cb;
      ld._load_start('admin_cleaner_date_get.php');
    },
    checkout_list_get_cb (res) {
      this.work_list = res.data.listings;
    },
    status_text (status) {
      if (status === 1) {
        return '未清掃';
      } else if (status === 2) {
        return '清掃済み';
      } else {
        return '確認済み';
      }
    },
    list_info (item) {
      if (item.status === 1) {
        return;
      }
      this.$router.push({name: 'clean_info', params: {date: this.disp_date, listing_id: item.listing_id}});
    },
    renew () {
      this.data_get(this.disp_date.substr(0, 6));
      this.checkout_list_get(this.disp_date);
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.owner-box {
  text-align: left;

  .main-container {
    h3 {
      margin-bottom: 8px;
    }
    .list-box {
      margin-bottom: 8px;
      div {
        padding: 8px;
        border-bottom: 1px solid #cccccc;
        display: flex;
        transition: all 0.2s ease;
        .time {
          margin-left: auto;
          font-size: 0.8rem;
          margin-top: 2px;
        }
        .room-name {
        }
        .status {
          width: 64px;
          font-size: 0.8rem;
          border-radius: 4px;
          margin-right: 8px;
          font-weight: bold;
          padding: 2px 4px;
          text-align: center;
          color: #fefefe;
        }
        .status1 {
          background: #ef8d42;
        }
        .status2 {
          background: #4284ef;
        }
        .status3 {
          background: #45b32d;
        }
      }
      div:hover {
        background: #efefef;
      }
    }
    .button {
      margin-top: 25px;
      width: 150px;
      height: 40px;
      border: initial;
      border-radius: 4px;
      font-size: 16px;
      display: block;
      margin: 24px auto;
    }
  }
  @media (max-width: 767px) {
    .main-container {
      .date-box {
        width: calc(100vw - 20px);
      }
    }
  }
}
</style>
